import { z } from 'zod';
/**
 * Check-in semanal do aluno (P2 do personal, estudo: "peso, sono, energia, dor, foto"). Um por
 * semana (a segunda-feira é a chave: mandar de novo na mesma semana troca). Vai para o personal
 * do estúdio; a foto, se houver, fica cifrada como as da avaliação.
 */
export const CHECKIN_SCALE_LABEL = ['Muito ruim', 'Ruim', 'Normal', 'Bom', 'Ótimo'];
export const checkinInputSchema = z.object({
    weightKg: z.number().min(20).max(400).nullable(),
    /** 1 (muito ruim) a 5 (ótimo). */
    sleep: z.number().int().min(1).max(5),
    energy: z.number().int().min(1).max(5),
    /** 0 (nenhuma) a 10 (a pior). */
    pain: z.number().int().min(0).max(10),
    painWhere: z.string().trim().max(120).default(''),
    note: z.string().trim().max(400).default(''),
    photo: z
        .object({ mime: z.enum(['image/jpeg', 'image/webp']), data: z.string().min(16).max(1_300_000) })
        .optional(),
});
export const checkinSchema = z.object({
    id: z.uuid(),
    /** A segunda-feira da semana (AAAA-MM-DD). */
    week: z.string(),
    sentAt: z.iso.datetime(),
    weightKg: z.number().nullable(),
    sleep: z.number(),
    energy: z.number(),
    pain: z.number(),
    painWhere: z.string(),
    note: z.string(),
    hasPhoto: z.boolean(),
});
